import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const designation = async (): Promise<any> => {
  const designation = useJSONStore.getState().designation;
  const token = useUserStore.getState().userToken;
  const setDesignation = useJSONStore.getState().setDesignation;

  if (designation.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.designation}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setDesignation(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default designation;
